export const HEADING = 'Your Programs';

export const DESCRIPTION_1 =
	'Choose how members of your team can charge to this account when they use Xpress.';

export const DESCRIPTION_2 =
	'Set limits based on location, time, budget and vehicle type.';

export const ACTIVE_PROGRAM_TAB = 'Active Program';
export const INACTIVE_PROGRAM_TAB = 'Inactive Program';
